import { projects as s } from "../../types/projects/index.js";
import { DaymapQuery as c, DaymapInfiniteQuery as l } from "../daymapQuery.js";
var u;
((o) => {
  class g extends c {
    constructor(e) {
      super(
        ["GetProjectConfig", e.id],
        e,
        `/lms/api/projects/configuration/${e.id}`,
        null,
        {
          stale: 1e3 * 60 * 10,
          select: (n) => ({
            ...n,
            Flags: n.Flags,
            ProjectConfigPermissions: new s.ProjectConfigPermissions(n.ProjectConfigPermissions)
          }),
          enabled: !!e.id
        }
      );
    }
  }
  o.GetProjectConfig = g;
  class P extends c {
    constructor(e) {
      super(
        ["GetProjectForms", e.configId, e.admin],
        e,
        `/lms/api/projects/configuration/${e.configId}/forms${e.admin ? "?admin=true" : ""}`,
        null,
        { stale: 1e3 * 60 * 10, enabled: !!e.configId }
      );
    }
  }
  o.GetProjectForms = P;
  class f extends c {
    constructor(e) {
      super(
        ["GetProjectsForStudent", e.configId, e.studentId],
        e,
        `/lms/api/projects/${e.configId}/students/${e.studentId}`,
        null,
        { stale: 1e3 * 60 * 10 }
      );
    }
  }
  o.GetProjectsForStudent = f;
  class j extends c {
    constructor(e) {
      super(
        ["GetProject", e.projectId],
        e,
        `/lms/api/projects/${e.projectId}/details`,
        null,
        {
          stale: 1e3 * 60 * 10,
          select: (n) => n && { ...n, Created: new Date(n.Created), Modified: n.Modified ? new Date(n.Modified) : null },
          enabled: !!e.projectId
        }
      );
    }
  }
  o.GetProject = j;
  class I extends c {
    constructor(e) {
      super(
        ["GetProjectPeople", e.projectId],
        e,
        `/lms/api/projects/${e.projectId}/people`,
        null,
        {
          stale: 1e3 * 60 * 10,
          enabled: !!e.projectId
        }
      );
    }
  }
  o.GetProjectPeople = I;
  class S extends c {
    constructor(e) {
      super(
        ["GetProjectRecordForStudent", e.projectId, e.studentId],
        e,
        `/lms/api/projects/${e.projectId}/records/${e.studentId ? e.studentId : "0"}`,
        null,
        {
          select: (n) => n.map((t) => ({ ...t, Created: new Date(t.Created), Modified: t.Modified ? new Date(t.Modified) : null })),
          stale: 1e3 * 60 * 10,
          enabled: !!e.projectId
        }
      );
    }
  }
  o.GetProjectRecordForStudent = S;
  class m extends c {
    constructor(e) {
      super(
        ["GetProjectEventsForStudent", e.projectId, e.studentId],
        e,
        `/lms/api/projects/${e.projectId}/events/${e.studentId ? e.studentId : "0"}`,
        null,
        {
          select: (n) => n.map((t) => ({ ...t, Start: new Date(t.Start), End: new Date(t.End) })),
          stale: 1e3 * 60 * 10,
          enabled: !!e.projectId
        }
      );
    }
  }
  o.GetProjectEventsForStudent = m;
  class G extends c {
    constructor(e) {
      super(
        ["GetProjectListForStudent", e.configId, e.studentId],
        e,
        `/lms/api/projects/list/${e.configId}${e.studentId ? `?studentId=${e.studentId}` : ""}`,
        null,
        {
          stale: 1e3 * 60 * 10,
          select: (n) => n.map((t) => ({
            ...t,
            Created: new Date(t.Created),
            NextEvent: t.NextEvent ? new Date(t.NextEvent) : void 0,
            Reccurance: t.Reccurance ? { ...t.Reccurance, Start: new Date(t.Reccurance.Start) } : void 0,
            RecentEvents: (t.RecentEvents || []).map((a) => ({
              ...a,
              Start: new Date(a.Start),
              End: a.End ? new Date(a.End) : a.End
            }))
          }))
        }
      );
    }
  }
  o.GetProjectListForStudent = G;
  class C extends c {
    constructor(e) {
      super(
        ["GetAllProjectConfigs"],
        e,
        "/lms/api/projects/configuration/all",
        null,
        {
          stale: 1e3 * 60 * 10,
          select: (n) => n.map((r) => ({
            ...r,
            Flags: r.Flags,
            ProjectConfigPermissions: new s.ProjectConfigPermissions(r.ProjectConfigPermissions)
          }))
        }
      );
    }
  }
  o.GetAllProjectConfigs = C;
  class x extends c {
    constructor(e) {
      super(
        ["CreateProjectConfig"],
        e,
        "/lms/api/projects/configuration",
        null,
        {
          enabled: !1
        }
      );
    }
  }
  o.CreateConfig = x;
  class $ extends c {
    constructor(e) {
      super(
        ["UpdateProjectConfig", e.data.Id],
        e,
        `/lms/api/projects/configuration/${e.data.Id}`,
        null,
        {
          enabled: !1
        }
      );
    }
  }
  o.UpdateConfig = $;
  class D extends c {
    constructor(e) {
      super(
        ["DeleteProjectConfig", e.Id],
        e,
        `/lms/api/projects/configuration/${e.Id}/delete`,
        null,
        {
          enabled: !1
        }
      );
    }
  }
  o.DeleteConfig = D;
  class F extends c {
    constructor(e) {
      super(
        ["GetAllNotificationConfigs", e.configId],
        e,
        `/lms/api/projects/notifications/${e.configId}/all`,
        null,
        { stale: 1e3 * 60 * 10 }
      );
    }
  }
  o.GetAllNotificationConfigs = F;
  class w extends c {
    constructor(e) {
      super(
        ["GetProjectLogs", e.projectId],
        e,
        `/lms/api/projects/${e.projectId}/logs`,
        null,
        {
          stale: 1e3 * 60 * 10,
          select: (n) => n.map((t) => ({ ...t, Changed: new Date(t.Changed), ActionType: t.ActionType }))
        }
      );
    }
  }
  o.GetProjectLogs = w;
  class R extends l {
    constructor(e) {
      const n = e.dateField ?? 0, r = e.pageSize ?? 50;
      super(
        ["GetProjectAdminReportPaged", e.configId, n, e.from, e.to, r],
        e,
        `/lms/api/projects/reports/${e.configId}/admin`,
        null,
        {
          infiniteQueryUrl: (t) => {
            const a = new URLSearchParams({
              dateField: n.toString(),
              pageSize: r.toString(),
              pageIndex: t.toString()
            });
            return e.from && a.append("from", e.from.toISOString()), e.to && a.append("to", e.to.toISOString()), `/lms/api/projects/reports/${e.configId}/admin?${a.toString()}`;
          },
          getNextPageParam: (t) => {
            const a = Math.ceil(t.TotalCount / t.PageSize), i = t.PageIndex + 1;
            return i <= a ? i : void 0;
          },
          initialPageParam: 1,
          stale: 1e3 * 60 * 10
        }
      );
    }
  }
  o.GetProjectAdminReportPaged = R;
  class v extends l {
    constructor(e) {
      const n = e.dateField ?? 0, r = e.pageSize ?? 50;
      super(
        ["GetProjectStudentReportPaged", e.configId, e.studentId, n, e.from, e.to, r],
        e,
        `/lms/api/projects/reports/${e.configId}/student/${e.studentId}`,
        null,
        {
          infiniteQueryUrl: (t) => {
            const a = new URLSearchParams({
              dateField: n.toString(),
              pageSize: r.toString(),
              pageIndex: t.toString()
            });
            return e.from && a.append("from", e.from.toISOString()), e.to && a.append("to", e.to.toISOString()), `/lms/api/projects/reports/${e.configId}/student/${e.studentId}?${a.toString()}`;
          },
          getNextPageParam: (t) => {
            const a = Math.ceil(t.TotalCount / t.PageSize), i = t.PageIndex + 1;
            return i <= a ? i : void 0;
          },
          initialPageParam: 1,
          stale: 1e3 * 60 * 10
        }
      );
    }
  }
  o.GetProjectStudentReportPaged = v;
})(u || (u = {}));
export {
  u as projects
};
//# sourceMappingURL=index.js.map
